<template>
  <vue-toggles v-bind="finalProps" @click="onClick"></vue-toggles>
</template>

<script>
import { VueToggles } from 'vue-toggles';
import cssVariables from '@versions/x/styles/variables.module.scss';

export default {
  components: {
    VueToggles,
  },
  props: {
    modelValue: {
      type: Boolean,
    },
    height: {
      type: String,
      default: '22',
    },
    width: {
      type: String,
      default: '54',
    },
    checkedBg: {
      type: String,
      default: cssVariables.primary,
    },
    fontSize: {
      type: String,
      default: '13',
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ['change', 'update:modelValue'],
  computed: {
    finalProps() {
      return {
        checkedText: this.$t('common.on'),
        uncheckedText: this.$t('common.off'),
        ...this.$props,
        ...this.$attrs,
      };
    },
  },
  methods: {
    onClick() {
      const newValue = !this.modelValue;
      this.$emit('change', newValue);
      this.$emit('update:modelValue', newValue);
    },
  },
};
</script>
